import { EmailComponentWrapper } from "../../utils/email-component-wrapper";
import { PickupPointBlockEmail } from "./email";
import type { PickupPointBlockProps } from "./types";

export function PickupPointWeb(props: PickupPointBlockProps) {
  return (
    <EmailComponentWrapper shop={props.shop}>
      <PickupPointBlockEmail {...props} />
    </EmailComponentWrapper>
  );
}
